// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "business-35uHg";
var _4 = "descriptions-1JJnJ";
var _5 = "header-XlYJK";
var _6 = "price_from-24thB";
var _7 = "button__remove-3vFA0";
var _8 = "paper-1T1lM";
var _9 = "serviceSelect-24DBS";
var _a = "serviceSelect_aggregator-32e9f";
var _b = "scrollBody-3kO_y";
var _c = "business_aggregator-2w7l_";
export { _1 as "__esModule", _2 as "mobile", _3 as "business", _4 as "descriptions", _5 as "header", _6 as "price_from", _7 as "button__remove", _8 as "paper", _9 as "serviceSelect", _a as "serviceSelect_aggregator", _b as "scrollBody", _c as "business_aggregator" }
export default { "__esModule": _1, "mobile": _2, "business": _3, "descriptions": _4, "header": _5, "price_from": _6, "button__remove": _7, "paper": _8, "serviceSelect": _9, "serviceSelect_aggregator": _a, "scrollBody": _b, "business_aggregator": _c }
